export default __webpack_public_path__ + "static/media/gm-sp-girl.b50e5f9e.webp";